import type { AttachContractAttachmentPayload } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import type { UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import {
  zodAttachContractAttachmentEndpointSchema,
  zodAttachContractAttachmentPayloadSchema,
} from './validations';

/**
 * Confirms a staged file upload and permanently attaches it to a contract.
 * Call this after uploading a file via the signed URL flow.
 *
 * @param contractId - The ID of the contract to attach the file to.
 * @param payload - The attachment payload containing file ID, name and MIME type.
 * @param options - Optional request options (e.g., abort signal).
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Contracts/operation/attach_attachment_contracts__contract_id__attachments_put
 */
export const attachContractAttachment = async (
  contractId: UUID,
  payload: AttachContractAttachmentPayload,
  options?: KyRequestOptions,
) => {
  const response = await vestigasApi
    .post(ENDPOINT.CONTRACT_ATTACHMENT.ADD(contractId), {
      json: payload,
      validate: {
        body: zodAttachContractAttachmentPayloadSchema,
        pathSegments: zodAttachContractAttachmentEndpointSchema,
      },
      ...options,
    })
    .json<void>();

  return response;
};
